var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"facebook","d":"M1.985,16V8.492H0v-2.7H1.985V3.48C1.985,1.666,3.158,0,5.86,0a16.406,16.406,0,0,1,1.9.1L7.7,2.629s-.825-.008-1.725-.008c-.974,0-1.131.449-1.131,1.194V5.789H7.776l-.128,2.7H4.843V16H1.985"}));
}

Facebook.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 7.776 16","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Facebook;

Facebook.default = Facebook;
